import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { MatchCard } from './match-card';

export const MatchCardScoreFetcher = ({
    voteData,
    totalVotes,
    seasonPid,
    seasonId,
    modifier,
    isVisible,
    linkTo,
    playerModalEnabled
}) => {
    const dispatch = useDispatch();
    const matchData = useSelector((state) =>
        PULSE.app.redux.selectors.match.item(state, voteData.matchId)
    );

    useEffect(() => {
        // Fetch match data if the card is visible and we don't have matchData
        if (isVisible && !matchData) {
            dispatch(
                window.PULSE.app.redux.actions.match.ADD_MATCH.request(
                    voteData.matchId
                )
            );
        }
    }, [voteData.matchId, dispatch, isVisible, matchData]);

    return (
        <MatchCard
            voteData={voteData}
            matchData={matchData}
            totalVotes={totalVotes}
            seasonPid={seasonPid}
            seasonId={seasonId}
            modifier={modifier}
            linkTo={linkTo}
            playerModalEnabled={playerModalEnabled}
        />
    );
};

MatchCardScoreFetcher.propTypes = {
    voteData: PropTypes.object,
    totalVotes: PropTypes.object,
    seasonPid: PropTypes.string,
    seasonId: PropTypes.string,
    modifier: PropTypes.string,
    isVisible: PropTypes.bool.isRequired,
    linkTo: PropTypes.string,
    playerModalEnabled: PropTypes.bool
};
